import React from 'react';
import PropTypes from 'prop-types';

const Grid = (props) => {
  return (
    <div
      className={`grid grid--columns-${props.columns.length} ${props.className}`}
    >
      {props.columns.map((column, i) => (
        <div key={i} className="grid__item">
          {column}
        </div>
      ))}
    </div>
  );
};

Grid.propTypes = {
  columns: PropTypes.array,
  className: PropTypes.string,
};

export default Grid;
